/**
 * Appels API pour la vue équipe (squad lead).
 */

import api from "./axiosConfig";

export async function getTeamContacts(sortBy = "last_name", company = "") {
  const params = new URLSearchParams({ sort_by: sortBy });
  if (company) params.set("company", company);
  const response = await api.get(`/team/contacts?${params.toString()}`);
  return response.data;
}

export async function getTeamTodos(sortBy = "due_date", status = null) {
  let url = `/team/todos?sort_by=${sortBy}`;
  if (status) url += `&status=${status}`;
  const response = await api.get(url);
  return response.data;
}

export async function getTeamActions(sortBy = "action_date") {
  const response = await api.get(`/team/spontaneous-actions?sort_by=${sortBy}`);
  return response.data;
}
